import { C } from '../styles';

export function P({ children }) {
  return <p style={{ color: C.mut, fontSize: 15, lineHeight: 1.8, marginBottom: 18 }}>{children}</p>;
}

export function H2b({ children }) {
  return (
    <h2 style={{
      fontFamily: "'Barlow Condensed', sans-serif", fontSize: 'clamp(22px, 3vw, 30px)',
      fontWeight: 700, textTransform: 'uppercase', color: C.txt,
      marginTop: 40, marginBottom: 14,
    }}>{children}</h2>
  );
}

export function H3b({ children }) {
  return (
    <h3 style={{
      fontFamily: "'Barlow Condensed', sans-serif", fontSize: 19,
      fontWeight: 700, color: C.txt, marginTop: 26, marginBottom: 10,
    }}>{children}</h3>
  );
}

export function UL({ children }) {
  return <ul style={{ margin: '0 0 18px', paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 8 }}>{children}</ul>;
}

export function LI({ children }) {
  return <li style={{ color: C.mut, fontSize: 15, lineHeight: 1.75 }}>{children}</li>;
}
